<script>
import baseEdit from '@/views/components/base/baseEdit.vue'
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'backstageLog',
      key:'id',
       url: {

        },
      items: [
        { label: '基本信息', desc: '表单的基本信息', type: 'header' },
        {
          label: '操作单元',
          name: 'workshop',
          value: '',
          type: 'input',
          width:'300px',
          rules: [{ required: true, trigger: 'blur', }],
        },
        { label: '分类编号', name: 'backstageLogDetail', value: '', type: 'input',width:'300px'},
        //{ label: "状态", name: "status", value: 1, type: "switch", trueValue: 1, falseValue: 0 },
      ],
      forms: {
        id:"",
        createBy:$utils.data.get("auth", "customer")
      },
    }
  },
  created() {
  },
  methods: {
    initData() {
      // 加载详情数据
      let id = this.kv;
      this.forms.id = id;
      $utils.api.load(`/admin/backstageLog/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data
        }
      })
    },
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      this.forms.id=this.$route.query.kv
      let q = this.forms;
      this.forms.label = q.id;
      const action=this.$route.query.action
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true
          if(action=='edit'){
            $utils.api
                .load(`/admin/backstageLog/update`, q,  'POST')
                .then((res) => {
                  this.sloading = false
                  if (res.status) {
                    $utils.toast.success('保存成功')
                    $utils.url.go(-1)
                  }
                })
                .catch((e) => {
                  this.sloading = false
                  $utils.toast.error('保存异常' + e.message)
                })
          }else{ $utils.api
              .load(`/admin/backstageLog/add`, q,  'POST')
              .then((res) => {
                this.sloading = false
                if (res.status) {
                  $utils.toast.success('保存成功')
                  $utils.url.go(-1)
                }
              })
              .catch((e) => {
                this.sloading = false
                $utils.toast.error('保存异常' + e.message)
              })}
        }
      });
    },
  },
}
</script>
